import ReactDOMServer from 'react-dom/server';
import SelectResponsible from '../../../../../../components/form/Selects/SelectResponsible';
import Translator from '../../../../../../components/helpers/Translator';

export default function ChangeBlockResponsible(props) {
  const {
    handleAddResponsibleEvent,
    handleDeleteResponsibleEvent,
    values,
  } = props;
  return (
    <>
      <SelectResponsible
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-correctiveActions"
            name="module.ca.edit-employee-add"
          />
        )}
        value={values.addResponsibleIDs}
        onHandleChange={(opt) => handleAddResponsibleEvent(opt)}
        hasSearchBox
        isClearable
        onlyWithPlantAccess
        hasSelectOptions
      />
      <SelectResponsible
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-correctiveActions"
            name="module.ca.edit-employee-delete"
          />
        )}
        value={values.deleteResponsibleIDs}
        onHandleChange={(opt) => handleDeleteResponsibleEvent(opt)}
        hasSearchBox
        isClearable
        onlyWithPlantAccess
        hasSelectOptions
      />
    </>
  );
}
